<template>
<div class="container">
    <div class="common-header-wrap">
        <mt-header title="店铺资料" class="common-header">
            <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
    </div>
    <div class="header">
        <div class="header-wrapper">
            <div class="content-wrapper">
                <div class="avatar">
                    <img :src="store.store_avatar">
                </div>
                <div class="content">
                    <div class="store_name">{{store.store_name}}</div>
                    <div class="follow_number">已经有{{store.store_collect}}人收藏</div>
                </div>
                <div class="follow_panel" :class="{'active':store.is_favorate}">
                    <div class="follow_button" @click="toggleFavorite" >
                        <i class="iconfont" v-if="!store.is_favorate">&#xe64e;</i>
                        {{favoriteName}}
                    </div>
                </div>
            </div>
            <div class="store_credit">
                <ul>
                    <li>
                        <span class="text">{{deliverycredit_text}}</span>
                        <span class="credit store_deliverycredit">{{deliverycredit_credit}}分</span>
                    </li>
                    <li>
                        <span class="text">{{desccredit_text}}</span>
                        <span class="credit store_desccredit">{{desccredit_credit}}分</span>
                    </li>
                    <li>
                        <span class="text">{{servicecredit_text}}</span>
                        <span class="credit store_servicecredit">{{servicecredit_credit}}分</span>
                    </li>
                </ul>
            </div>

            <div class="info-wrapper">
                <div class="info-item">
                    <div class="item price">{{ store.goods_count }}</div>
                    <div class="item">全部商品</div>
                </div>
                <div class="info-item">
                    <div class="item price">{{ store.seller_name }}</div>
                    <div class="item">店铺掌柜</div>
                </div>
            </div>
        </div>
        <div class="shopping-about">
            <flex-line :show-border="true" @click.native="imageVisible=true">
                <span>店铺二维码</span>
                <span slot="right" class="right-icon iconfont">&#xe6e0;</span>
            </flex-line>
            <a :href="'tel:'+ store.store_phone">
            <flex-line :show-border="true">
                <span>商家电话</span>
                <span slot="right" class="right-icon iconfont">&#xe6d1;</span>
            </flex-line>
            </a>
        </div>
        <div class="store_info mt-5">
            <flex-line :show-border="true"><span class="line-name">公司名称</span><span slot="right">{{store.store_company_name}}</span></flex-line>
            <flex-line :show-border="true"><span class="line-name">公司地区</span><span slot="right">{{store.area_info}}</span></flex-line>
            <flex-line :show-border="true"><span class="line-name">主营商品</span><span slot="right">{{store.store_mainbusiness}}</span></flex-line>
            <flex-line :show-border="true"><span class="line-name">店铺QQ</span><span slot="right">{{store.store_qq}}</span></flex-line>
            <flex-line :show-border="true"><span class="line-name">店铺旺旺</span><span slot="right">{{store.store_ww}}</span></flex-line>
        </div>
    </div>

    <common-store-footer :store_id="store.store_id"></common-store-footer>
    <mt-popup v-model="imageVisible" popup-transition="popup-fade" class="middle-popup">
        <h4>{{store.store_name}}</h4>
        <div class="img-new-box"><img :src="qrcodeurl"></div>
        <p>邀请好友扫一扫分享店铺给TA</p>
    </mt-popup>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import CommonStoreFooter from '../common/CommonStoreFooter'
import { getStoreInfo } from '../../../api/homestoredetail'
import { addFavoriteStore, delFavoriteStore } from '../../../api/memberFavorite'
import flexLine from '../../flexLine'
export default {
  name: 'Storeabout',
  data () {
    return {
      imageVisible: false,
      store: {
        store_id: this.$route.query.id ? this.$route.query.id : ''
      },
      rec_goods_list: false,
      popupVisible: false, // 弹出更多
      showDot: false,
      deliverycredit_text: '',
      deliverycredit_credit: 0,
      desccredit_text: '',
      desccredit_credit: 0,
      servicecredit_text: '',
      servicecredit_credit: 0,
      qrcodeurl: ''
    }
  },
  components: {
    flexLine,
    CommonStoreFooter
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
      token: state => state.member.token,
      isOnline: state => state.member.isOnline
    }),
    favoriteName () {
      return this.store.is_favorate ? '已收藏' : '收藏'
    }
  },
  created () {
    getStoreInfo(
      this.store.store_id, this.token
    ).then((res) => {
      this.store = res.result.store_info
      this.qrcodeurl = env.API_HOST + '/index/getQrcode?url=' + encodeURIComponent(env.H5_HOST + '/home/storedetail?id=' + this.store.store_id)
      this.rec_goods_list = res.result.rec_goods_list
      this.deliverycredit_text = res.result.store_info.store_credit.store_deliverycredit.text
      this.deliverycredit_credit = res.result.store_info.store_credit.store_deliverycredit.credit
      this.desccredit_text = res.result.store_info.store_credit.store_desccredit.text
      this.desccredit_credit = res.result.store_info.store_credit.store_desccredit.credit
      this.servicecredit_text = res.result.store_info.store_credit.store_servicecredit.text
      this.servicecredit_credit = res.result.store_info.store_credit.store_servicecredit.credit
      if (this.store.is_platform_store) {
        this.fetchConfig({}).then(
          response => {
          },
          error => {
            Toast(error.message)
          }
        )
      }
    }).catch(function (error) {
    })
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    // 弹出更多
    popupMore () {
      if (!this.popupVisible) {
        this.popupVisible = true
      } else {
        this.popupVisible = false
      }
    },
    toggleFavorite () {
      if (!this.store.is_favorate) {
        addFavoriteStore(this.store.store_id).then(
          response => {
            Toast(response.message)
            this.store.is_favorate = !this.store.is_favorate
          },
          error => {
            Toast(error.message)
          }
        )
      } else {
        delFavoriteStore(this.store.store_id).then(
          response => {
            Toast(response.message)
            this.store.is_favorate = !this.store.is_favorate
          },
          error => {
            Toast(error.message)
          }
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">
    .header {overflow: hidden;position: relative;background-position: center;background-size: auto 100%;}
    .header .content-wrapper {-ms-flex-align: center;-webkit-box-align: center;align-items: center;display: -webkit-box;display: -ms-flexbox;display: flex;padding:0.8rem 0.5rem;position: relative;background: #fff}
    .header .content-wrapper .avatar {-ms-flex: 0 0 3rem;-webkit-box-flex: 0;flex: 0 0 3rem;margin-right:0.4rem;width:3rem;    border: 1px solid #efefef;}
    .header .content-wrapper .avatar img {border-radius:0.1rem;width:3rem;height:3rem;}
    .header .content-wrapper .content {position:relative;width:8rem;height:3rem;margin-left: .5rem}
    .header .content-wrapper .content .store_name {font-size:$h2;;margin-bottom:.4rem;font-weight: 700}
    .header .content-wrapper .content .follow_number{line-height:0.7rem;font-size:$fontSize;margin-top:0.1rem;color: #999}
    .follow_panel{position:absolute;top:1rem;right:$pageSpace;}
    .follow_panel .follow_button{display:block;background:$primaryColor;border:1px solid #fff;border-radius:2.5rem;padding:0 0.4rem;line-height:1.2rem;font-size:$fontSize;color:#fff;width:2.4rem;text-align: center}
    .follow_panel .follow_button i{line-height:1.2rem;}
    .store_credit{background: #fff;padding: 0px .5rem 2rem;}
    .store_credit ul li{display: inline-block;width: 33%;text-align: center}
    .store_credit ul li .text{font-size:$fontSize}
    .store_credit ul li .credit{font-size:$fontSize;margin-left: .2rem;color:$primaryColor}
    .header-wrapper{position: relative;box-shadow: 0px 4px 4px #f7f7f7;}
    .info-wrapper {
        position: absolute;
        bottom:-2rem;
        left:1.5rem;
        right:1.5rem;
        display: inline-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-content: stretch;
        background-color: $primaryColor;
        border-radius: .4rem;
        z-index: 2;
    }
    .info-item {
        flex: 1;
        text-align: center;
        font-size: $fontSize;
        color:#fff;
        position: relative;
        &:first-child::after{content:'';position: absolute;top:.5rem;bottom:.5rem;right:0;border-right: 1px dashed rgba(255,255,255,.5);}
        .item{padding-top:.5rem;padding-bottom:.5rem;}
        .price{font-size:$h2;padding-bottom:0}
    }
    .shopping-about{background: #fff;padding:0 $pageSpace;padding-top:2.5rem;
        .right-icon{font-size:$mainFontSize;color:$formInputColor;}
    }
    .store_info {background: #fff;padding:0 $pageSpace;}
    .header .background {-webkit-filter: blur(0.5rem);filter: blur(0.5rem);height: 100%;left: 0;position: absolute;top: 0;width: 100%;z-index: -1;}
    .middle-popup h4{    font-size:$h3; text-align: center; padding: .6rem;  border: 1px solid #eee; color: #444;}
    .middle-popup .img-new-box{background: #fff; padding: .75rem; margin: .5rem .65rem;height: auto}
    .middle-popup .img-new-box img{width: 100%}
    .middle-popup p{font-size:$fontSize;color: #777; text-align: center; padding: .4rem; border-top: 1px solid #eee;}
</style>
